// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CHANGED_AVATAR = "si zm\u011bnila profilovou fotku";
export const CHILD_ADDED = "p\u0159idala dceru do sv\u00e9ho profilu";
export const CHILD_ADDED_DAUGHTER = "p\u0159idala dceru do sv\u00e9ho profilu";
export const CHILD_ADDED_SON = "p\u0159idala syna do sv\u00e9ho profilu";
export const CHILD_EDITED_DAUGHTER = "zm\u011bnila fotku sv\u00e9 dcery";
export const CHILD_EDITED_SON = "zm\u011bnila fotku sv\u00e9ho syna";
export const counter_NEW_PHOTOS = ["%(counter)s nov\u00e1 fotka", "%(counter)s nov\u00e9 fotky", "%(counter)s nov\u00fdch fotek"];
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotek"];
export const EXPERIENCE_ADDED = "p\u0159idala hodnocen\u00ed";
export const FORUM_THREAD_ADDED = "zalo\u017eila diskuzi";
export const GROUP_MODERATOR_SHORT = "Moder\u00e1tor";
export const NEW_POST = "Nov\u00fd";
export const NUMBER_OF_VIEWS_count = "\u010cten\u00e9 %(count)sx";
export const number_MINUTES = ["%(number)s minuta", "%(number)s minuty", "%(number)s minut"];
export const PB_POST_HAS_BEEN_EDITED = "Zpr\u00e1va byla zm\u011bn\u011bna";
export const PB_SHARED_A_POST = "sd\u00edlela p\u0159\u00edsp\u011bvek";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku";
export const READ_WHOLE_ARTICLE = "\u010cti cel\u00fd \u010dl\u00e1nek";
export const RECIPE_ADDED = "p\u0159idala recept";
export const RECIPE_CREATE_FROM_POST_HINT = "P\u0159em\u011b\u0148 na recept \u2192 hez\u010d\u00ed design, suroviny, postup";
export const SHOW = "Zobraz";
export const SHOW_FULL_MESSAGE = "Zobraz celou zpr\u00e1vu";
